// Public mirror of the existing SJ Property Care plan catalog (setup_stripe.py + /plans endpoint).
// Names, prices, taglines, features and the disclaimer match the app exactly — nothing invented.
export const MOST_POPULAR = "sj_portfolio_monthly";

export const PUBLIC_PLANS = [
  {
    lookup_key: "sj_starter_monthly", name: "Starter", amount: 199, tagline: "Up to 5 properties", property_limit: 5,
    best_for: "Best for smaller portfolios of up to 5 properties",
    features: ["Maintenance request portal", "Work order tracking", "Photo documentation", "Invoice history", "Standard support"],
  },
  {
    lookup_key: "sj_portfolio_monthly", name: "Portfolio", amount: 399, tagline: "Up to 20 properties", property_limit: 20,
    best_for: "Best for growing portfolios of up to 20 properties",
    features: ["Everything in Starter", "Recurring maintenance", "Property turnover management", "Priority dispatch", "Portfolio reporting"],
  },
  {
    lookup_key: "sj_pro_monthly", name: "Pro", amount: 699, tagline: "Up to 50 properties", property_limit: 50,
    best_for: "Best for larger portfolios of up to 50 properties",
    features: ["Everything in Portfolio", "Advanced reporting", "Priority scheduling", "Multi-user access", "Custom maintenance programs", "Dedicated account support"],
  },
  {
    lookup_key: "sj_enterprise", name: "Enterprise", amount: null, tagline: "Custom pricing", property_limit: null,
    best_for: "Best for large portfolios needing custom property limits and workflows",
    features: ["Custom property limits", "Custom workflows", "Dedicated account management", "Advanced reporting", "Volume pricing", "Custom service agreements", "Multiple locations"],
  },
];

export const PLANS_DISCLAIMER = "Monthly subscription fees do not include repair labor, contractor labor, materials, emergency service, project work, turnover work, or other service charges. Those are billed separately.";
